import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import Button from "../../shared/button/Btn"
import { showModal, showNestedModal } from '../../../features/modal/modalSlice'
import { useDispatch } from 'react-redux'
import {  addDevamliAraclarPlaka, addDevamliAracPlaka, addSiraListesi, clearJobListWithoutGunlukAraclar, deleteDevamliAraclarPlaka, deleteVehicleRegisteredUser, driverSearch, fromUserToDevamliArac, getDevamliAracItem, multipleCitySelectArray, setDevamliAraclarKayitliArac, setSelectedPlateNumber, setShowNewCar } from '../../../features/joblist/jobListSlice'
import { useSelector } from 'react-redux'
import moment from 'moment'
import 'moment/locale/tr';
import KasaTipiInput from "../inputs/KasaTipiInput"
import SelectAracInput from "../inputs/SelectAracInput"
import PlateInput from "../inputs/PlateInput"
import { AdminAracEkleOptions } from '../../../utils/adminAracEkleOptions'
import SelectAracDurumuInput from '../queueInputs/SelectAracDurumuInput'
import AracNeredeInput from '../queueInputs/AracNeredeInput'
import GidebilecekBolgelerInput from '../queueInputs/GidebilecekBolgelerInput'
import GidebilecekIllerInput from '../queueInputs/GidebilecekIllerInput'
import DateInput from "../inputs/DateInput"
import iller from '../../../utils/iller'
import bolgeOptions from '../../../utils/yukOptions/bolgeOptions'
import locationData from '../../../utils/locationData/locationOptions'
import SelectPlateInput from '../queueInputs/SelectPlateInput'
import SmallSpinner from '../../shared/spinners/SmallSpinner'
import SelectTrailerPlateInput from '../queueInputs/SelectTrailerPlateInput'


const Container = styled.div`
    width: 100%;
    height: 100%;
    .container{
        width: 100%;
        margin: 0 auto;
        padding: 10px;
        position: relative;
        .row{
            width: 100%;
            display: flex;
            align-items: center;
            margin-block: 15px;
            .title{
                font-weight: var(--font-weight-lg);
                font-size: var(--font-size-sm);
                width: 350px;
            }
            .text{
                font-weight: var(--font-weight-md);
                font-size: var(--font-size-sm);
                display: flex;
                align-items: center;
                
                .selected{
                    color: var(--color-dark);
                    border: none;
                }
            }
            .plaka{
                color: var(--color-main);
                font-size: var(--font-size-sm);
                border: 1px solid var(--color-main);
                padding: 5px;
                border-radius: 10px;
            }
        }
        .car-row{
            display: flex;
            flex-direction: column;
            gap: 10px;
            .title{
                font-weight: var(--font-weight-lg);
                font-size: var(--font-size-sm);
                width: 350px;
                text-decoration: underline;
            }
            .text{
                font-weight: var(--font-weight-md);
                font-size: var(--font-size-sm);
                display: flex;
                align-items: center;
            }
            .show-all{
                font-weight: var(--font-weight-md);
                font-size: var(--font-size-sm);
                color: var(--color-main);
                text-decoration: underline;
                cursor: pointer;
            }
        }
        .new-cars{
            border-top: 2px solid;
            border-color: ${({ theme }) => theme.mainBorderColor};
            padding-top: 20px;
            margin-top: 20px;
            .add-plate{
                color: var(--color-main);
                /* border: 1px solid var(--color-main); */
                padding: 5px;
                border-radius: 10px;
                text-decoration: underline;
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
                cursor: pointer;
                display: inline-block;
            }
            .toplu-ekle{
                color: var(--color-main);
                border: 1px solid var(--color-main);
                padding: 5px;
                border-radius: 10px;
                font-size: var(--font-size-sm);
                cursor: pointer;
                display: inline-block;
            }
        }
        .daily-inputs{
            border-top: 2px solid;
            border-color: ${({ theme }) => theme.mainBorderColor};
            padding-top: 20px;
            margin-top: 20px;
            .title{
                font-size: var(--font-size-lg);
                font-weight: var(--font-weight-md);
            }
        }
    }

    .btn{
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 15px;
        margin-top: 30px;
    }

    .relative{
        position: relative;
        cursor: pointer;
        .invite{
            position: absolute;
            right: -50px;
            top: -5px;
            color: var(--color-main);
            font-size: 12px;
            border: 1px solid var(--color-main);
            padding: 5px;
            border-radius: 10px;
            cursor: pointer;
        }
        .plates{
            position: absolute;
            top: 0;
            right: 80px;
            border: 1px solid var(--color-main);
            padding:5px;
            border-radius: 10px;
            background-color: white;
            z-index: 9;
            p{
                font-weight: var(--font-weight-md);
                font-size: var(--font-size-sm);
                margin-block: 5px;
            }
        }
    }
    .space{
        justify-content: space-between;
    }
`

const aracDurumu = [
    {
        id: 1,
        text: "Boşta Hazır",
    },
    {
        id: 2,
        text: "Yük Boşaltıyor",
    },
    {
        id: 3,
        text: "Yolda",
    },
    {
        id: 4,
        text: "Yarın Boşta",
    },
];

const DriverSearchContent = ({data}) => {
  const dispatch = useDispatch()
  const {activeSelect} = useSelector(state => state.layout)
  const [allPlates, setAllPlates] = useState([])
  const [isSubmitted, setIsSubmitted] = useState(false)
  const {dailyVehicleList, vehicleData, selectedPlateNumber, showNewCar, errorMessage, loadingAddDriver, selectedTrailerPlateNumber, isForGunlukArac} = useSelector((state) => state.jobList)
  const { vehicleStatus, vehicleCurrentLocation, timeToWaste, gunlukAracListesiCityCanGos, gunlukAracListesiRegionCanGos } = dailyVehicleList;
  const { devamliAraclarPlakas } = vehicleData
 
    const handleSave = () => {
        setIsSubmitted(true)

        const postDriverData = {
            firstLastName: data?.firstLastName,
            phoneNumber: data?.phoneNumber,
            isContinueVehicle: data?.isContinueVehicle,
            devamliAraclarPlakas: [...data?.devamliAraclarPlakas?.trucks, ...data?.devamliAraclarPlakas?.trailer]?.map((item) => {
                return { "plate": item?.plate, "truckType": item?.truckType, "truckTypeId": item?.truckTypeId, "trailerTypeId": item?.trailerTypeId }
            })
        };
        const gunluk = {
            "vehicleStatus": vehicleStatus,
            "vehicleCurrentLocation": vehicleCurrentLocation,
            "timeToWaste": timeToWaste || null,
            "truckPlate": selectedPlateNumber?.plate,
            trailerPlate: selectedTrailerPlateNumber?.plate || null,
            "gunlukAracListesiCityCanGos": gunlukAracListesiCityCanGos?.map((item) => {
                return { cityCanGo: item?.value };
            }),
            "gunlukAracListesiRegionCanGos": gunlukAracListesiRegionCanGos?.map((item) => {
                return { regionCanGo: item?.text };
            })
        };
    
        const isGunlukEmpty = !gunluk.vehicleStatus && !gunluk.vehicleCurrentLocation && !gunluk.timeToWaste && !gunluk.truckPlate && gunluk.gunlukAracListesiCityCanGos.length < 1 && gunluk.gunlukAracListesiRegionCanGos.length < 1;
        const hasPlate = devamliAraclarPlakas.some(item => item.plate && item.plate.trim() !== "")
        
        if(!hasPlate){
            if (isGunlukEmpty) {
                dispatch(addSiraListesi({ ...postDriverData, gunlukArac: null }));
            } else if(!isGunlukEmpty && selectedPlateNumber) {
                dispatch(addSiraListesi({ ...postDriverData, gunlukArac: gunluk }));
            }
        }
        
        dispatch(getDevamliAracItem(postDriverData));
    };
    


    useEffect(()=>{
        setAllPlates(data?.devamliAraclarPlakas.trucks)
    },[data])

    const bottomRef = useRef(null);

    useEffect(() => {
        if ((activeSelect === 'gunlukAracListesiRegionCanGos' || activeSelect === 'gunlukAracListesiCityCanGos') && bottomRef.current) {
        bottomRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [activeSelect]);

    useEffect(() => {
        const selectedCities = gunlukAracListesiRegionCanGos.map((item) => {
        return iller.filter((innerItem) => {
            return innerItem.region === item.text
        })
        }).flat(Infinity)
        dispatch(multipleCitySelectArray(selectedCities));
    },[gunlukAracListesiRegionCanGos])

    const handleSubmitNewCar = () => {
        if(devamliAraclarPlakas.some(item => item.plate && item.truckType && item.plate.trim() !== "")){
            dispatch(addDevamliAracPlaka(devamliAraclarPlakas?.map((item) => {
                return {userId: data?.userId, "plate": item?.plate, "truckType": item?.truckType, "truckTypeId": item?.truckTypeId, "trailerTypeId": item?.caseType?.id }
            })))
        }
    }
    const handleDeleteNewCar = (newCar) => {
            dispatch(deleteVehicleRegisteredUser(newCar))
    }

    // useEffect(() => {
    //     if(allPlates?.length < 2){
    //         dispatch(setSelectedPlateNumber(allPlates?.[0]))
    //     }
    // }, [allPlates])

    return (
    <Container >        

        <div className="container" >
            
            {/* //! kayıtlı kullanıcı bilgileri  */}
            <div className="row">
                <div className="title">Adı Soyadı:</div>
                <div className="text">{data?.firstLastName}</div>
            </div>
            <div className="row">
                <div className="title">Telefon No:</div>
                <div className="text">{data?.phoneNumber}</div>
            </div>
            <div className="row">
                <div className="title">Devamlı Araç mı?:</div>
                <div className="text">{data?.isContinueVehicle === false ? "Hayır" : "Evet"}</div>
            </div>
            <div className="row">
                <div className="title">Referans Mısınız?:</div>
                <div className="text">{data?.isReferenceDriver === false ? "Hayır" : "Evet"}</div>
            </div>
            

            <div className="car-row">
                <div className="title">Araçlar ({allPlates?.length} Araç)</div>
                {allPlates?.map((item) => (
                    <div className="text">{item.plate} - {item.truckType} - {item.userType === 0 && "Kendi Aracı" } {item.userType === 1 && "Şirket Aracı" } {item.userType === 2 && "Sürücü Aracı" }</div>
                )).slice(0, 5)}
                {allPlates?.length > 5 &&
                    <div onClick={()=> { dispatch(showNestedModal("devamliAraclarAracListeleme")); dispatch(setDevamliAraclarKayitliArac(allPlates)) }} className="show-all">Tümünü Gör</div>
                }
            </div>
            
            {/* //! yeni araç ekleme alanı  */}
            <div className='new-cars'>
            {
                showNewCar ?
                    <div className="add-plate" onClick={()=>dispatch(addDevamliAraclarPlaka())}>Yeni Araç Ekle</div>
                    :
                    <div className="add-plate" onClick={() => dispatch(setShowNewCar(true))}>Yeni Araç Ekle</div>
            }
                
            {
                showNewCar &&  
                <>
                    {devamliAraclarPlakas.map((item,i)=>{
                        const newIndex = i+1
                        return(
                        <div>
                            <div className="row space">
                                <div className="plate-title">{newIndex}. Araç</div>
                                {devamliAraclarPlakas?.length > 1 && <div className="plate-delete" onClick={()=>{dispatch(deleteDevamliAraclarPlaka(item)); handleDeleteNewCar(item)}}>Aracı Sil</div> }
                                {devamliAraclarPlakas?.length === 1 && <div className="plate-delete" onClick={()=>{dispatch(setShowNewCar(false)); handleDeleteNewCar(item)}}>Aracı Sil</div> }
                            </div>
                            <div className="row">
                                <PlateInput inputWidth="100%" name={`plate${i}`} data={item} keyData="plate" labelText="Araç Plaka"/>
                            </div>
                            <div className="row">
                                <SelectAracInput options={AdminAracEkleOptions} inputWidth="100%" name={`truckType${i}`} data={item} labelText="Araç Türü" />
                            </div>
                            {
                                item?.truckType !== "Çekici" && 
                                <div className="row">
                                    <KasaTipiInput aracTypes={AdminAracEkleOptions} inputWidth="100%" name={`caseType${i}`} data={item} labelText="Kasa Tipi" />
                                </div>
                            }
                        </div>
                    )})}
                    {devamliAraclarPlakas?.length >= 1 && <div className="toplu-ekle" onClick={handleSubmitNewCar}>Araçları Kaydet</div> }
                </>
            }
            </div>

            {/* //! sıraya ekleme bilgileri  */}
            <div className="daily-inputs">
                <div className="title">Sıraya Kayıt</div>
                <div className="row">
                    <SelectPlateInput options={allPlates} labelText={"Araç Plakası"} data={selectedPlateNumber?.plate} name={"selectedPlateNumber"} inputWidth={"100%"} />
                </div>
                {
                    (selectedPlateNumber?.truckType === "Çekici" || selectedPlateNumber?.truckType === "Kırkayak" || selectedPlateNumber?.truckType === "10 Teker Kamyon") && 
                    <div className="row">
                        <SelectTrailerPlateInput options={data?.devamliAraclarPlakas?.trailer} labelText={"Dorse Plakası"} data={selectedTrailerPlateNumber?.plate} name={"selectedTrailerPlateNumber"} inputWidth={"100%"} />
                    </div>
                }
                
                <div className="row">
                    <SelectAracDurumuInput
                        options={aracDurumu}
                        inputWidth="100%"
                        name="vehicleStatus"
                        data={vehicleStatus}
                        labelText="Araç Durumu"
                        keyData="vehicleStatus"
                    />
                </div>
                <div className="row">
                    <AracNeredeInput
                        options={locationData}
                        inputWidth="100%"
                        name="vehicleCurrentLocation"
                        data={vehicleCurrentLocation}
                        labelText="Araç Nerede"
                        keyData="vehicleCurrentLocation"
                    />
                </div>
                <div className="row">
                    <DateInput
                        options={aracDurumu}
                        inputWidth="100%"
                        name="timeToWaste"
                        data={timeToWaste}
                        labelText="Boşa Çıkma Zamanı"
                        keyData="timeToWaste"
                    />
                </div>
                <div className="row">
                    <GidebilecekBolgelerInput
                        options={bolgeOptions}
                        inputWidth="100%"
                        name="gunlukAracListesiRegionCanGos"
                        data={gunlukAracListesiRegionCanGos}
                        labelText="Hangi Bölgelere Gidebileceği"
                        keyData="gunlukAracListesiRegionCanGos"
                    />
                </div>
                <div className="row">
                    <GidebilecekIllerInput
                        options={iller}
                        inputWidth="100%"
                        name="gunlukAracListesiCityCanGos"
                        data={gunlukAracListesiCityCanGos}
                        labelText="Hangi İllere Gidebileceği"
                        keyData="gunlukAracListesiCityCanGos"
                    />
                </div>
            </div>

            {isSubmitted && devamliAraclarPlakas.some(item => item.plate && item.plate.trim() !== "") && 
                <p className='err'>Sıraya eklemeden önce yeni oluşturduğunuz araçları kaydediniz.</p>
            }

            {isSubmitted && (gunlukAracListesiRegionCanGos.length < 1 || gunlukAracListesiCityCanGos.length < 1 || timeToWaste || vehicleCurrentLocation || vehicleStatus) && !selectedPlateNumber && 
                <p className='err'>Sıraya eklemeden önce araç plakasını seçiniz.</p>
            }

            <p className="err">{errorMessage}</p>

            <div ref={bottomRef} className='btn'>
                <Button handleClick={handleSave} color='#E85446' padding='10px' width={"120px"}>{loadingAddDriver ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Kaydet"}</Button>
                <Button handleClick={()=> {dispatch(showModal(null)); dispatch(clearJobListWithoutGunlukAraclar()) }} bgColor='#E85446' color='#fff' padding='10px' width={"120px"}>Kapat</Button>
            </div>
        </div>
        
    </Container>
  )
}

export default DriverSearchContent